import Topnav from './components/Navbar';
import Welcome from './components/Welcome';
import "../src/css/styles.css"
import "../src/css/materialize.css"
import "../src/css/gallery.css"
import WeAreKarot from './components/WeAreKarot';
import WhatWeDeal from './components/WhatWeDeal';
import RecentWork from './components/RecentWork';
import OurTechnologies from './components/OurTechnologies';
import ContactUs from './components/ContactUs';

function App() {
  return (
    <div className="App">
      <Welcome/>
      <WeAreKarot/>
      <WhatWeDeal/>
      <RecentWork/>
      <OurTechnologies/>
      <ContactUs/>
    </div>
  );
}

export default App;
